import { DropdownOptionType, IDropdownMenuOption } from '@evinced-private/ui-common';

type getEvincedAppsMenuOptionsHelperArgs = {
	hasMfaLicense: boolean;
	hasMsdkLicense: boolean;
	hasSiteScannerLicense: boolean;
	hasWebSdkLicense: boolean;
	hasPlatformLicense: boolean;
};

export const getEvincedAppsDropdownMenuOptions = (
	licenses: getEvincedAppsMenuOptionsHelperArgs
): IDropdownMenuOption[] => {
	const {
		hasMfaLicense,
		hasMsdkLicense,
		hasSiteScannerLicense,
		hasWebSdkLicense,
		hasPlatformLicense
	} = licenses;

	const isMFADashboard = window.location.href.includes(import.meta.env.VITE_MFA_DASHBOARD_URL);
	const isMobileSDK = window.location.href.includes(import.meta.env.VITE_MOBILE_SDK_DASHBOARD_URL);
	const isSiteScanner = window.location.href.includes(import.meta.env.VITE_SITE_SCANNER_URL);
	const isProductHub = window.location.href.includes(import.meta.env.VITE_PRODUCT_HUB_URL);

	const defaultProps = {
		type: DropdownOptionType.LINK,
		hasBottomBorder: false,
		openInNewTab: true
	};

	const appsList = [
		{
			id: 'mfa-dashboard-url',
			url: import.meta.env.VITE_MFA_DASHBOARD_URL,
			title: 'Mobile Flow Analyzer',
			active: isMFADashboard,
			hasLicense: hasMfaLicense,
			...defaultProps
		},
		{
			id: 'mobile-sdk-dashboard-url',
			url: import.meta.env.VITE_MOBILE_SDK_DASHBOARD_URL,
			title: 'Mobile SDKs',
			active: isMobileSDK,
			hasLicense: hasMsdkLicense,
			...defaultProps
		},
		{
			id: 'web-sdk-dashboard-url',
			url: import.meta.env.VITE_WEB_SDK,
			title: 'Web SDKs',
			active: false,
			hasLicense: hasWebSdkLicense,
			...defaultProps
		},
		{
			id: 'wfa-dashboard-url',
			url: import.meta.env.VITE_WFA_DASHBOARD_URL,
			title: 'Web Flow Analyzer',
			active: false,
			hasLicense: hasPlatformLicense,
			...defaultProps
		},
		{
			id: 'site-scanner-url',
			url: import.meta.env.VITE_SITE_SCANNER_URL,
			title: 'Site Scanner',
			active: isSiteScanner,
			hasLicense: hasSiteScannerLicense,
			...defaultProps
		},
		{
			id: 'product-hub',
			url: import.meta.env.VITE_PRODUCT_HUB_URL,
			title: 'Product Hub',
			active: isProductHub,
			hasLicense: true,
			...defaultProps
		}
	];

	return appsList.filter((app) => app.hasLicense);
};
